import { render, staticRenderFns } from "./Sites.vue?vue&type=template&id=33476e96&scoped=true"
import script from "./Sites.vue?vue&type=script&lang=ts"
export * from "./Sites.vue?vue&type=script&lang=ts"
import style0 from "./Sites.vue?vue&type=style&index=0&id=33476e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33476e96",
  null
  
)

export default component.exports